/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'gh-setup-scheduling-schedule-templates-tab',
  templateUrl: 'scheduling-schedule-templates-tab.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SchedulingScheduleTemplatesTabComponent {
}
